import type { ReactNode } from 'react';

/** Schlanker Rahmen für Seiten ohne Anmeldung (Passwort vergessen / zurücksetzen) */
export function AuthCard({ title, subtitle, children }: { title: string; subtitle?: ReactNode; children: ReactNode }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-50 p-6">
      <div className="w-full max-w-sm">
        <img src="/brand/logo-dark.png" alt="Mietverwaltung Portal – Klar und digital" className="mx-auto mb-8 h-auto w-full max-w-[280px]" width={280} height={33} />
        <div className="rounded-xl border border-slate-200 bg-white p-6 shadow-sm">
          <h1 className="text-xl font-semibold text-slate-900">{title}</h1>
          {subtitle && <p className="mt-1 text-sm text-slate-500">{subtitle}</p>}
          <div className="mt-5">{children}</div>
        </div>
      </div>
    </div>
  );
}
